import 'react-native-gesture-handler'
import React, { useState, useMemo } from 'react'
import { View } from 'react-native'
import { AppLoading } from 'expo'
import { Asset } from 'expo-asset'
import { NavigationContainer } from '@react-navigation/native'
import { SafeAreaProvider } from 'react-native-safe-area-context'

import './i18n'
import RootStack from './RootStack'
import { AstrolabeProvider } from './modules/astrolabe'
import { LocalPreferenceProvider } from './modules/global'
import { AuthProvider } from './modules/signIn'

if (!__DEV__) {
  console.log = () => {}
  console.info = () => {}
  console.debug = () => {}
  console.warn = () => {}
}

const loadAssets = async () => {
  return Promise.all([
    Asset.loadAsync([]),
  ])
}

export default function App() {
  const [isResourceLoaded, setIsResourceLoaded] = useState(false)
  const [layoutSize, setLayoutSize] = useState(window.innerWidth)
  const isWideScreen = useMemo(() => layoutSize >= 1024, [layoutSize])

  console.log('layoutSize: ', layoutSize, isWideScreen)

  return (
    <SafeAreaProvider>
      <View
        style={{ flex: 1 }}
        onLayout={({ nativeEvent }) => {
          setLayoutSize(nativeEvent.layout.width)
        }}>
        <LocalPreferenceProvider>
          <NavigationContainer>
            {isResourceLoaded ? (
              <AuthProvider>
                <AstrolabeProvider>
                  <RootStack isWideScreen={isWideScreen} />
                </AstrolabeProvider>
              </AuthProvider>
            ) : (
              <AppLoading
                startAsync={loadAssets}
                onError={error => {
                  // In this case, you might want to report the error to your error
                  // reporting service, for example Sentry
                  console.warn(error)
                }}
                onFinish={() => setIsResourceLoaded(true)}
              />
            )}
          </NavigationContainer>
        </LocalPreferenceProvider>
      </View>
    </SafeAreaProvider>
  )
}